<span
  [class]="
    'irembo-change-request-badge badge ' +
    getOrganizationStatusLabel(changeRequestStatus).class
  ">
  {{ getOrganizationStatusLabel(changeRequestStatus).label }}
</span>
